export default __webpack_public_path__ + "static/media/NewBanner2.7cb43cc3.png";